export default "__VITE_ASSET__249f990a__"